export const propertyUseOptions = [
    {
        key: 'community-garden',
        label: 'Community Garden',
        value: 'community-garden'
    },
    {
        key: 'green-house',
        label: 'Green House',
        value: 'green-house'
    },
    {
        key: 'play-area',
        label: 'Play Area',
        value: 'play-area'
    },
    {
        key: 'build-home',
        label: 'Build Home',
        value: 'build-home'
    },
    {
        key: 'build-shed-garage',
        label: 'Build Shed/Garage',
        value: 'build-shed-garage'
    },
    {
        key: 'demolish-existing-structure',
        label: 'Demolish Existing Structure',
        value: 'demolish-existing-structure'
    },
    {
        key: 'rehab-existing-structure',
        label: 'Rehab Existing Structure',
        value: 'rehab-existing-structure'
    },
    {
        key: 'primary-residence',
        label: 'Primary Residence',
        value: 'primary-residence'
    },
    {
        key: 'rental',
        label: 'Rental',
        value: 'rental'
    },
    {
        key: 'other',
        label: 'Other (please indicate in description of planned improvements)',
        value: 'other'
    }
];
